module.exports = __webpack_public_path__ + "img/triangle_exclamation.d85dc940.svg";